<div class="validation-panel">
	<skl-validation-icon
		[hidden]="!allWarnings.length"
		[messages]="allWarnings"
		[violation]="'warning'">
	</skl-validation-icon>
	<skl-validation-icon
		[hidden]="!errorMessages.length"
		[ngClass]="{ 'align--tiny-left': allWarnings.length }"
		[messages]="errorMessages"
		[violation]="'error'">
	</skl-validation-icon>
</div>